import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL

const ContactService = {
    getContactSubmissions: async function() {
        const response = await axios.get(`${API_URL}/contactSubmission`, null, {
            crossDomain: true,
        });
        return response.data;
    },
};

export default ContactService;